// extracted by mini-css-extract-plugin
export var growableInput = "_5q-0";
export var tagContainer = "_5q-2";
export var textInput = "_5q-1";